module.exports = __webpack_public_path__ + "img/gzherweima.75f453ca.jpg";